import { isNil } from "lodash";
import { useSearchParams } from "react-router-dom";
import ProtectedRoute from "../../../../components/protected-route/protected-route";
import { hasElements } from "../../../../core/utils";
import useOnce from "../../../../hooks/use-once";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import useStorage from "../../../../hooks/use-storage";
import { PagoPendienteRespuesta, ResumenOperacion } from "../types/pagos.types";

const PagosPayworksPage = () => {
	const { pop } = useStorage<PagoPendienteRespuesta[]>();
	const { push } = useStorage<ResumenOperacion>();
	const [searchParams] = useSearchParams();
	const navigate = usePathNavigate();

	useOnce(() => {
		const pagos = pop("pagosEnviados");
		const reference = searchParams.get("reference");
		const returnCode = Number(searchParams.get("returnCode"));
		const confirmationNumber = searchParams.get("confirmationNumber");
		const message = searchParams.get("message");

		if (isNil(reference) || !hasElements(pagos)) {
			navigate("/:segmento/Pagos");
			return;
		}

		push("resumenOperacion", { formaPago: 5, datos: { reference, returnCode, confirmationNumber, message } });

		if (pagos.length === 1) {
			navigate("/:segmento/pagos/individual", { state: pagos });
		} else {
			navigate("/:segmento/pagos/multiples", { state: pagos });
		}
	});

	return (
		<ProtectedRoute>
			<h3>Procesando respuesta</h3>
		</ProtectedRoute>
	);
};

export default PagosPayworksPage;